import type { Kanal } from "../api";

interface Props {
  beschaeftigt: boolean;
  /** Zuletzt bekannter Verzögerungsstand je Kanal (Minuten); null, solange unbekannt. */
  stand: Record<Kanal, number | null>;
  onErhoehen: (kanal: Kanal, schrittMin: number) => void;
  onZuruecksetzen: (kanal: Kanal) => void;
}

const KANAELE: { kanal: Kanal; label: string }[] = [
  { kanal: "LIEFERUNG", label: "Lieferung" },
  { kanal: "ABHOLUNG", label: "Abholung" },
];

/** Der Verzögerungs-Hebel des Kochs (ADR-0003): je Kanal +15/+30 Minuten oder zurücksetzen. */
export function VerzoegerungHebel({ beschaeftigt, stand, onErhoehen, onZuruecksetzen }: Props) {
  return (
    <div className="hebel">
      <h2>Verzögerung</h2>
      {KANAELE.map(({ kanal, label }) => (
        <div key={kanal} className="hebel-zeile">
          <span className="hebel-label">
            {label}
            {stand[kanal] != null && <span className="hebel-stand"> (+{stand[kanal]} Min)</span>}
          </span>
          <div className="knopf-reihe">
            <button
              type="button"
              className="knopf sekundaer klein"
              disabled={beschaeftigt}
              onClick={() => onErhoehen(kanal, 15)}
            >
              +15
            </button>
            <button
              type="button"
              className="knopf sekundaer klein"
              disabled={beschaeftigt}
              onClick={() => onErhoehen(kanal, 30)}
            >
              +30
            </button>
            <button
              type="button"
              className="knopf klein"
              disabled={beschaeftigt}
              onClick={() => onZuruecksetzen(kanal)}
            >
              Zurücksetzen
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
